/* eslint-disable max-len */
import React from 'react';

const MentalHealth = () => (
  <div className="p-3 discover">
    <div className="p-3">
      <div className="container-profile profile-item subheader">
        <p>心理健康自救互助指南</p>
      </div>
    </div>
    <div className="container-col-article-details">
      <div className="container-row-license">
        <div className="container-row-license-item">
          1.待补充中
        </div>
      </div>
    </div>
  </div>
);

export default MentalHealth;
